/* tslint:disable */
import './edit'
import './form'
import './link'
import './news'
import './profile'
import './tel'
